import { useEffect, useState } from "react";
import { useConnect } from "@stacks/connect-react";
import axios from "axios";
import { BsHourglassSplit } from "react-icons/bs";
import { FaRegGem } from "react-icons/fa";
import { RxValueNone } from "react-icons/rx";
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import { network, authenticatedUserAddress } from '../../services/auth';
import { clientNetwork, cryptoCashCoreAddress, stacksApi } from "../../lib/constants";
import { AnchorMode, cvToJSON, hexToCV, listCV, uintCV } from "@stacks/transactions";
import { getDeruptCoreContractPrivately } from "../../services/chime";

const ClaimMineRewardButton = ({ claimed, winner, claimHightBlock, pending, setConfirmTx, setShowConfirmModal }) => {
    const [minedRewardState, setMinedRewardState] = useState('');
    const { doContractCall } = useConnect();

    const memPoolChecker = async () => {
        try {
            const userAddress = authenticatedUserAddress({ network: clientNetwork });
            const { results } = (await axios.get(`${stacksApi[clientNetwork]}/extended/v1/tx/mempool?address=${userAddress}`)).data;
            results.forEach(({ tx_type, contract_call }) => {
                if (tx_type === "contract_call" && contract_call) {
                    const { contract_id, function_name, function_args } = contract_call;
                    if (contract_id === cryptoCashCoreAddress && ["claim-mining-reward", "claim-mining-reward-list"].includes(function_name)) {
                        const claimHeight = cvToJSON(hexToCV(function_args[1]?.hex))?.value;
                        if (parseInt(claimHightBlock) === parseInt(claimHeight)) {
                            setMinedRewardState('mempool');
                        }
                    }
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    const claimMinReward = async () => {
        const coreAddress = await getDeruptCoreContractPrivately();
        if (!coreAddress) return;

        doContractCall({
            contractAddress: coreAddress.split('.')[0],
            contractName: coreAddress.split('.')[1],
            functionName: 'claim-mining-reward-list',
            functionArgs: [listCV([uintCV(claimHightBlock)])],
            network,
            anchorMode: AnchorMode.Any,
            onFinish: ({ txId }) => {
                setConfirmTx(txId);
                setShowConfirmModal(true);
                setMinedRewardState('mempool');
            },
            onCancel: () => {
                console.log("Action cancelled");
            }
        });
    };

    useEffect(() => {
        if (pending) {
            setMinedRewardState('pending');
        } else if (winner && !claimed) {
            setMinedRewardState('unclaimed');
        } else if (winner && claimed) {
            setMinedRewardState('claimed');
        } else if (!winner) {
            setMinedRewardState('lost');
        }
    }, [claimed, winner, pending]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            memPoolChecker();
        }, 30000);
        return () => clearInterval(intervalId);
    }, []);

    return (
        <div id="reward-status-container">
            {minedRewardState === "pending" && <BsHourglassSplit />}
            {minedRewardState === "unclaimed" && <button className='reward-button' onClick={claimMinReward}><FaRegGem /></button>}
            {minedRewardState === "mempool" && <button className='reward-button-disabled' disabled><HourglassTopIcon /></button>}
            {minedRewardState === "lost" && <RxValueNone />}
            {minedRewardState === "claimed" && <FaRegGem />}
        </div>
    );
};

export default ClaimMineRewardButton;